import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page history-page" }
const _hoisted_2 = { class: "casino-card-glow history-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GameHistoryList = _resolveComponent("GameHistoryList")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "page-title" }, "Game History", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_GameHistoryList, { games: _ctx.games }, null, 8, ["games"])
    ]),
    _createVNode(_component_router_link, {
      to: "/",
      class: "btn-outline"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode("Back to Play", -1)
      ]))]),
      _: 1
    })
  ]))
}